import script from "./cashDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./cashDrawer.vue?vue&type=script&setup=true&lang=js"

import "./cashDrawer.vue?vue&type=style&index=0&id=25ad7350&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ad7350"]])

export default __exports__